<template>
  <div>
    <div class="px-3">
      <div v-if="loading" class="d-flex justify-center align-center h-64">
        <v-progress-circular
          :size="50"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-show="!loading">
        <div v-for="item in filterLimitRow" :key="item.id">
          <v-card-text class="flex align-center pr-0">
            <div class="recentTitle sm:1/4 xs:1/4 md:1/4 lg:1/6 xl:1/6 md:px-4">
              <div class="text-zt-lg font-bold">{{ sliceDate(item.ddmm) }}</div>
              <div
                v-if="item.dateToShow && item.data.length > numberShow"
                class="inline-block mt-2"
              >
                <zt-button
                  data-vs-button="show-more"
                  @click=";(item.dateToShow = false) + showMore(item.dateEs)"
                  color="primary"
                  outlined
                  icon="angle-down"
                  fab
                ></zt-button>
              </div>
              <div
                v-if="!item.dateToShow && item.data.length > numberShow"
                class="inline-block mt-2"
              >
                <zt-button
                  data-vs-button="show-less"
                  @click=";(item.dateToShow = true) + showLess(item.dateEs)"
                  color="primary"
                  outlined
                  icon="angle-up"
                  fab
                ></zt-button>
              </div>
            </div>
            <div :id="item.dateEs" class="d-flex flex-wrap rowsDiv">
              <div
                v-for="(element, index) in item.data"
                :key="index"
                class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 recentContainer"
              >
                <zt-tooltip
                  :text="`${element.nombre} ${element.apellido}`"
                  color="primary"
                >
                  <v-avatar
                    :class="
                      element.foto_perfil != '' &&
                      element.foto_perfil.includes('/profileimage')
                        ? ''
                        : 'bg-white border border-solid border-primary text-zt-primary-200 font-bold'
                    "
                    size="50"
                  >
                    <img
                      alt="imagen"
                      v-if="
                        element.foto_perfil != '' &&
                          element.foto_perfil.includes('/profileimage')
                      "
                      :src="element.foto_perfil"
                    />
                    <div v-else>
                      {{
                        element.nombre
                          .trim()
                          .charAt(0)
                          .toUpperCase() +
                          element.apellido
                            .trim()
                            .charAt(0)
                            .toUpperCase()
                      }}
                    </div>
                  </v-avatar>
                </zt-tooltip>
              </div>
            </div>
          </v-card-text>
          <hr />
        </div>
      </div>
      <div v-if="!loading" class="text-right">
        <button
          v-if="limitRow == 5 && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none"
          @click="limitRow = ''"
        >
          {{ $t('message.homeComponent.recentHired.show_more') }}
        </button>
        <button
          v-if="!limitRow && Rows.length > 5"
          class="sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 py-4 font-normal text-gray-600 focus:outline-none"
          @click="limitRow = 5"
        >
          {{ $t('message.homeComponent.recentHired.show_minus') }}
        </button>
      </div>
      <div
        v-if="!loading && !Rows.length"
        class="flex justify-center sm:3/4 xs:3/4 md:3/4 lg:5/6 xl:5/6 p-1 py-10 text-center "
      >
        <div class="grayFont--text text-zt-base font-normal">
          <div class="ghost m-auto mt-20"></div>
          <span>{{ $t('message.homeComponent.recentHired.no_events') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Users from '../../../apiClient/Users'
import moment from 'moment'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import i18n from '@/plugins/i18n'

export default {
  props: {
    handlerFilter: Boolean
  },
  data() {
    return {
      loading: true,
      Rows: [],
      numberShow: 8,
      limitRow: 5,
      show: false
    }
  },
  computed: {
    ...mapGetters({
      getUser: 'getUser', 
      locale: 'getLocale'   
    }),
    sliceDate() {
      return date => date.slice(0, -8)
    },
    filterLimitRow() {
      return this.limitRow ? this.Rows.slice(0, this.limitRow) : this.Rows
    },
    localeLang() {
      return this.locale === 'br' ? 'pt-br' : 'es'
    }
  },
  created() {
    this.user = new Users()
    this.getRecentHired()
    this.detectResolution()
  },
  methods: {
    detectResolution() {
      let resolution = window.screen.width
      switch (true) {
        case resolution < 500:
          this.numberShow = 6
          break
        case resolution >= 501 && resolution <= 1023:
          this.numberShow = 12
          break
        case resolution >= 1024 && resolution <= 1279:
          this.numberShow = 7
          break
        case resolution >= 1280 && resolution <= 1439:
          this.numberShow = 8
          break
        case resolution >= 1440 && resolution <= 1599:
          this.numberShow = 11
          break
        case resolution >= 1600 && resolution <= 1919:
          this.numberShow = 13
          break
        case resolution >= 1920 && resolution <= 2047:
          this.numberShow = 17
          break
        case resolution >= 2048:
          this.numberShow = 18
          break
      }
    },
    async getRecentHired() {
      const localTemp = this.locale === 'br' ? 'br' : 'es'
      try {
        const { data } = await this.user.getRecentHired()
        this.buildData(data.results.data)
        this.loading = false
      } catch (e) {
        this.loading = false;
        i18n.locale = localTemp
        const is401 = e.response && e.response.status === 401;
        const text = is401 ? this.$t('message.Errors.401.sub_title_401') : (e.message);
        const typeSwal = is401 ? 'info' : 'error';
        this.$swal({
        type: typeSwal,
        timer: 8000,
        text: text,
        showConfirmButton: true,
        confirmButtonText: this.$t("message.Pickup.accept")
        });
      }
    },
    buildData(data) {
      this.data = data
      const totalRow = _.uniqBy(data, r => r.dm)
      for (let i = 0; i < totalRow.length; i++) {
        this.Rows.push({
          dateEn: `${totalRow[i].mes}${'/'}${totalRow[i].dia}${'/2020'}`,
          dateEs: `${totalRow[i].dia}${'/'}${totalRow[i].mes}`,
          ddmm: moment(`${totalRow[i].mes}${'/'}${totalRow[i].dia}${'/2020'}`)
            .locale(this.localeLang)
            .format('LL'),
          data: this.filterData(`${totalRow[i].dia}${'/'}${totalRow[i].mes}`),
          dateToShow: true
        })
      }
    },
    filterData(date) {
      return this.data.filter(result => result.dm === date)
    },
    showMore(id) {
      document.getElementById(id).classList.remove('rowsDiv')
    },
    showLess(id) {
      document.getElementById(id).classList.add('rowsDiv')
    }
  }
}
</script>

<style lang="scss" scoped>
@import './public/assets/scss/_config.scss';

.ghost {
  content: url('data:image/svg+xml;base64,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');
}

.recentTitle {
  min-width: 150px;
}

.recentContainer {
  max-width: 60px;
  font-size: $font-small;
}

.border-primary {
  border-color: $primary-color-200;
}

.rowsDiv {
  @media (min-width: 900px) {
    $line-height: 5;
    $font-size: 15px;
    $lines: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  @media (max-width: 900px) {
    align-items: center;
    $lines: 8;
    $font-size: 14px;
    $line-height: 1;
    display: block;
    display: -webkit-box;
    height: $font-size * $line-height * $lines;
    font-size: $font-size;
    line-height: $line-height;
    -webkit-line-clamp: $lines;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
